import { EnvironmentProviders } from '@angular/core';
import { authInitializerProvider } from './auth.provider';
import { iconInitializerProvider } from '@app/utils/providers/icon.provider';
import { googleTagManagerInitializerProvider } from '@app/utils/providers/google-tag-manager.provider';

export const appInitializer: EnvironmentProviders[] = [
  authInitializerProvider,
  iconInitializerProvider,
  googleTagManagerInitializerProvider,
];
